import { useFormContext } from 'react-hook-form'
import { Typography, Stack } from '@mui/material_modern'
import InputV2 from 'components/generic/form/InputV2'
import Switch from 'components/generic/form/Switch'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import React from 'react'

const CommodityComplianceForm: React.FC = () => {
  const {
    setValue,
    control,
    watch,
    formState: { errors },
    clearErrors,
  } = useFormContext()

  const isWeightThresholdEnabled = watch('weightThreshold.enabled')
  const { defaultYardUm } = useAppSelector(state => state.settings)

  return (
    <Stack key="compliance" flexGrow={1} ml={4}>
      <Typography variant="h5">Compliance</Typography>
      <Stack mt={3} spacing={2}>
        <Stack direction="row" width={{ xs: '100%', md: '50%' }} alignItems="center">
          <Typography variant="h6" mr={1}>
            Weight Threshold
          </Typography>
          <Switch
            label="Enabled"
            name="weightThreshold.enabled"
            defaultValue={false}
            control={control}
            data-testid="weight-threshold-enabled"
            variant="outlined"
            onChange={() => ['weightThreshold'].forEach(value => clearErrors(value))}
          />
        </Stack>
        <Typography variant="body2" sx={{ marginTop: 0, marginBottom: 2 }}>
          Please note that weight thresholds will only apply to in-yard payments
        </Typography>
        <Stack width={{ xs: '100%', md: '50%' }}>
          <InputV2
            name="weightThreshold.amount"
            label={`Weight (${defaultYardUm})`}
            defaultValue={0}
            type="number"
            control={control}
            disabled={!isWeightThresholdEnabled}
            data-testid="weight-threshold-amount"
            variant="outlined"
            error={!!errors?.weightThreshold?.amount}
            helperText={errors?.weightThreshold?.amount?.message}
            onBlur={event => {
              if (!event.target.value) {
                setValue('weightThreshold.amount', '0')
              }
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default CommodityComplianceForm
